import React from 'react';
import { fontFamily, colour, ActionButton, Input } from './GlobalStyles';
import { useSelector, useDispatch } from 'react-redux';
import { emailAction } from './actions';
import './MobileBookPage.css';

const NameMobile = React.forwardRef((props, ref) => {

    const currentEmail = useSelector(state => state.emailAction);
    const dispatch = useDispatch();

    const styles = {
        headerText: {
            fontFamily: fontFamily,
            color: colour.dark,
            fontWeight: 'normal',
            fontSize: '1.375em',
            textAlign: 'center'
        },
        back: {
            fontFamily: fontFamily,
            color: colour.dark,
            fontSize: '0.875em',
            fontWeight: 'normal',
            textAlign: 'center',
            cursor: 'pointer'
        }
    }

    return (
        <div className="mobileBookPageOuterContainer">
            <h1 style={styles.headerText}>
                Inserisci la tua Mail
            </h1>
            <div>
                <Input
                    value={currentEmail}
                    id="outlined"
                    label="Email"
                    inputProps={{
                        autoCapitalize: 'none',
                    }}
                    variant="outlined"
                    onChange={(text) => dispatch(emailAction(text.target.value))}
                />
                <div style={{ height: '2vh' }} />
                <ActionButton
                    ref={ref} {...props}
                    disabled={
                                currentEmail === "" ?
                                true
                                :
                                false
                            }
                >
                    Continua
                </ActionButton>
                <div style={{ height: '2vh' }} />
                <p
                    onClick={() => props.onBack()} 
                    style={styles.back}
                >
                    Indietro
                </p>
            </div>
        </div>
    )
})

export default NameMobile;